import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Card, CardContent, Stack } from "@mui/material";
import { useSignUpMutation } from "Auth/Api/Mutations/useSignUpMutation";
import { BlFormInput } from "Forms/Components/BlFormInput";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const SignUpSchema = z
	.object({
		login: z.string().email(),
		password: z.string().min(6),
		passwordRepeat: z.string(),
		firstName: z.string(),
		lastName: z.string(),
	})
	.superRefine(({ passwordRepeat, password }, ctx) => {
		if (passwordRepeat !== password) {
			ctx.addIssue({
				code: "custom",
				message: "Hesla nejsou stejná",
				path: ["passwordRepeat"],
			});
		}
	});

type SignUpSchemaType = z.infer<typeof SignUpSchema>;

const PageResources = Resources.SignUp;

type Props = {};

export const UserNewForm: FunctionComponent<Props> = () => {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<SignUpSchemaType>({ resolver: zodResolver(SignUpSchema) });

	console.log(errors);
	const { t } = useResource();

	const signInMutation = useSignUpMutation();

	const submit = (data: SignUpSchemaType) => {
		signInMutation.mutate(data);
	};

	return (
		<Stack alignItems="center">
			<Card>
				<CardContent>
					<form onSubmit={handleSubmit(submit)} autoComplete="off">
						<BlFormInput
							control={control}
							name="login"
							errors={errors}
							label={t(PageResources.Login.Label)}
						/>

						<BlFormInput
							control={control}
							name="password"
							errors={errors}
							type="password"
							label={t(PageResources.Password.Label)}
							autoComplete="new-password"
						/>

						<BlFormInput
							control={control}
							name="passwordRepeat"
							errors={errors}
							type="password"
							label={t(PageResources.PasswordRepeat.Label)}
						/>

						<BlFormInput
							control={control}
							name="firstName"
							errors={errors}
							label={t(PageResources.FirstName.Label)}
						/>

						<BlFormInput
							control={control}
							name="lastName"
							errors={errors}
							label={t(PageResources.LastName.Label)}
						/>

						<Stack>
							<Button type="submit" color="primary" variant="contained">
								{t(PageResources.Button)}
							</Button>
						</Stack>
					</form>
				</CardContent>
			</Card>
		</Stack>
	);
};
